<template>
  <div :class="{ 'fixed': comment.isFixed }">
    <div class="comment-piece">
      <div
        v-if="isCompanyStaffAccess && comment.isFixed"
        data-test="fixed-for-boss-c"
        class="red fixed-label"
      >
        修正済み
      </div>
      <div
        v-if="!isCompanyStaffAccess"
        data-test="fixed-for-boss-s"
      >
        <!-- BOSS-S用機能：修正済みチェックボックス -->
        <label
          class="boss-checkbox"
          data-test="checkbox-label"
          :class="{ 'red': comment.isFixed }"
        >
          <input
            :checked="comment.isFixed"
            class="boss-input-checkbox"
            data-test="checkbox"
            type="checkbox"
            @click="toggleFixed"
          >{{ comment.isFixed | fixedText }}
        </label>
      </div>
      <div data-test="businesses-partner-name">
        【{{ comment.isCompanyStaff | businessesPartnerName }}コメント】
      </div>
      <div
        class="comment-update-date"
        data-test="author-and-date"
      >
        {{ comment.author }}{{ comment.isCompanyStaff | honorific }}（{{ comment.lastUpdateDate | formatDate }}）
      </div>
      <div
        v-if="!isEdit"
        class="comment pega-pre-wrap"
        data-test="comment"
        v-text="comment.comment"
      />
      <textarea
        v-else
        v-model="comment.comment"
        class="edit-comment"
        :class="{ 'pending': isPending }"
        data-test="edit-comment"
      />
      <div
        v-if="canEdit"
        class="edit-area"
        data-test="edit-icon-area"
      >
        <button
          class="boss-icon-pencil"
          data-test="icon-pencil"
          @click="toggleEdit"
        />
        <button
          class="boss-icon-trash"
          data-test="icon-trash"
          @click="doRemove"
        />
      </div>
    </div>
    <hr>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import jobPreviewCommon from '@/lib/jobPreviewCommon'

export default {
  filters: {
    formatDate (val, defaultLabel = '----/--/--(-)--:--') {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd)HH:mm') : defaultLabel
    },
    businessesPartnerName (val) {
      return val ? '企業担当者様' : '制作担当者'
    },
    honorific (val) {
      return val ? '様' : ''
    },
    fixedText (val) {
      return val ? '修正済み' : '修正済みにする'
    }
  },
  mixins: [jobPreviewCommon],
  props: {
    comment: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      isEditing: false
    }
  },
  computed: {
    isEdit () {
      return this.comment.isChanged || this.isEditing
    },
    isPending () {
      return !!this.comment.comment.trim() && this.comment.isChanged
    },
    // コメント変更可否
    canEdit () {
      // 編集中ではない かつ 自分のコメント かつ 修正済みでない場合のみ、変更・削除可能
      return !this.isEdit && this.myComment && !this.comment.isFixed
    },
    myComment () {
      return this.isCompanyStaffAccess === this.comment.isCompanyStaff
    }
  },
  watch: {
    comment () {
      // データリセット
      this.$set(this, 'isEditing', !!this.comment.isChanged)
    }
  },
  created () {
    // コメントが編集された際に1度だけ動かしたいため、createdでwatchメソッドを作る
    const unwatch = this.$watch('comment.comment', () => {
      // $listeners経由でJobPrePublishedPreviewまでemit
      this.$emit('changeComment', this.comment)
      unwatch() // watchを止める
    })
  },
  methods: {
    // 修正済み切り替え処理
    toggleFixed () {
      // $listeners経由でJobPrePublishedPreviewまでemit
      this.$emit('toggleFixed', [this.comment], !this.comment.isFixed) // 一括処理を利用するため配列で渡す
    },

    // 編集ボタン押下処理
    toggleEdit () {
      this.$set(this, 'isEditing', true)
      this.$emit('setLine')
    },

    // 削除ボタン押下処理
    doRemove () {
      this.$dialog.confirm('このコメントを削除しますか？')
        // はいを押下した時
        .then(() => {
          // $listeners経由でJobPrePublishedPreviewまでemit
          this.$emit('deleteComment', this.comment)
        })
        // いいえを押下した時（catch句を消すとコンソールに警告が出るから消さないでね！！）
        .catch(() => {})
    }
  }
}
</script>
